import React from 'react';
import Chart from '../../CommonComponents/Chart';

interface AssetAllocationChartData {
  Stocks?: number;
  Bonds?: number;
  Cash?: number;
}

interface Props {
  chartData: AssetAllocationChartData;
}

const AssetAllocationChart: React.FC<Props> = ({ chartData }) => {
  return (
    <div id="ExpressWizard_AllocationChart">
      <div className="chart_container">
        <Chart
          options={{
            chart: {
              plotBackgroundColor: null,
              plotBorderWidth: null,
              plotShadow: false,
              backgroundColor: 'transparent',
              spacing: [0, 0, 0, 0],
            },
            tooltip: {
              enabled: false,
              pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
            },
            plotOptions: {
              pie: {
                size: '100%',
                innerSize: '75%',
                dataLabels: {
                  enabled: false,
                },
                point: {
                  events: {},
                },
                borderWidth: 5,
                borderColor: '#FFF',
              },
            },
            series: [
              {
                type: 'pie',
                name: 'Asset Allocation',
                data: Object.keys(chartData).map(key => ({
                  y: chartData[key],
                  name: key,
                })),
              },
            ],
            colors: ADV.settings.expresswizard_colors,
            title: '',
            credits: {
              enabled: false,
            },
          }}
        />
      </div>
    </div>
  );
};

export default AssetAllocationChart;
